import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WarningModalContents from 'containers/WarningModal/WarningModalContents';
import { modalParamsSelector } from 'redux/modules/modal';
import { hideModal } from 'redux/modules/modal/actions';
import { block } from './utils';

function AdjustmentNeededModalContent() {
  const dispatch = useDispatch();
  const {
    description = 'For full-length projects we currently only support videos and GIFs as the top or bottom layer. Please adjust your layout and try again.',
  } = useSelector(modalParamsSelector) || {};

  return (
    <WarningModalContents
      title="Adjustment needed"
      className={block('content')}
      description={<>{description}</>}
      actions={[
        {
          theme: 'submit',
          onClick: () => {
            dispatch(hideModal(false));
          },
          children: 'Return to editing',
          id: 'return',
        },
      ]}
    />
  );
}

export default AdjustmentNeededModalContent;
